import React from 'react';
import IntroSection from '../components/IntroSection';
import CAOverview from '../components/CAOverview';
import BlueSectionDivider from '../components/BlueSectionDivider';
import CAProcess from '../components/CAProcess';
import TeamSection from '../components/TeamSection';
import WhyUsSection from '../components/WhyUsSection';
import WorkingModelSection from '../components/WorkingModelSection';
import TechStackSection from '../components/TechStackSection';
import CAFaq from '../components/CAFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const CodeAudit = ()=>{
    return (
        <div>
            <IntroSection title="CODE AUDIT" paragraph="We fail-proof your software to improve your product from its very core." backgroundImage="/images/ca-bg.webp"/>
            <CAOverview para1 ="Your product will only deliver a seamless user experience if built correctly. Our software audit services ensure a fine-tuned product from its very core."/>
            <BlueSectionDivider/>
            <CAProcess/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <CAFaq/>
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default CodeAudit;